﻿import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { withTheme, withStyles } from '@material-ui/core';

const styles = (theme) => {
  return {
    root: {
      width: 15,
      height: 18,
    },
  };
};

export default withTheme(
  withStyles(styles)((props) => {
    return (
      <SvgIcon width="22px" height="27px" viewBox={'0 0 22 27'} {...props}>
        <g id="Admin-V2-revision-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="document-types" transform="translate(-47.000000, -213.000000)" fillRule="nonzero">
            <g id="unknown" transform="translate(47.000000, 213.000000)">
              <path
                d="M15.09366,3.0375702e-13 L1.50936,3.0375702e-13 C0.67734,3.0375702e-13 -1.56141766e-12,0.675 -1.56141766e-12,1.50936 L-1.56141766e-12,25.49076 C-1.56141766e-12,26.32395 0.67617,27.00012 1.50936,27.00012 L19.62066,27.00012 C20.45502,27.00012 21.13002,26.32395 21.13002,25.49076 L21.13002,6.03756 L15.09366,3.0375702e-13 Z M15.09366,2.13399 L18.99726,6.03759 L15.09366,6.03759 L15.09366,2.13399 Z"
                id="Shape"
                fill="#00B7C1"
              ></path>
              <path
                d="M19.62192,25.49049 L1.50936,25.49049 L1.50936,1.50909 L13.58436,1.50909 L13.58436,6.03729 C13.58436,6.87048 14.25936,7.54665 15.09372,7.54665 L19.62192,7.54665 L19.62192,25.49049 Z"
                id="Path"
                fill="#E6F8F9"
              ></path>
              <path
                d="M10.41346,15.732 C10.50146,15.732 10.56946,15.708 10.61746,15.66 C10.66546,15.612 10.70946,15.536 10.74946,15.432 C10.75746,15.36 10.77746,15.224 10.80946,15.024 C10.85746,14.8 10.95146,14.59 11.09146,14.394 C11.23146,14.198 11.42946,13.964 11.68546,13.692 C12.03746,13.308 12.30346,12.968 12.48346,12.672 C12.66346,12.376 12.75346,12.028 12.75346,11.628 C12.75346,11.276 12.65546,10.936 12.45946,10.608 C12.26346,10.28 11.95146,10.01 11.52346,9.798 C11.09546,9.586 10.54946,9.48 9.88546,9.48 C9.24546,9.48 8.68946,9.598 8.21746,9.834 C7.74546,10.07 7.38346,10.38 7.13146,10.764 C6.87946,11.148 6.74546,11.56 6.72946,12 C6.72946,12.088 6.75546,12.16 6.80746,12.216 C6.85946,12.272 6.92546,12.3 7.00546,12.3 L7.00546,12.3 L8.04946,12.3 C8.22546,12.3 8.34146,12.208 8.39746,12.024 C8.55746,11.248 9.02546,10.86 9.80146,10.86 C10.14546,10.86 10.43946,10.956 10.68346,11.148 C10.92746,11.34 11.03346,11.6 11.00146,11.928 C10.98546,12.12 10.91146,12.304 10.77946,12.48 C10.64746,12.656 10.44546,12.88 10.17346,13.152 C9.82146,13.504 9.54546,13.824 9.34546,14.112 C9.14546,14.4 9.02546,14.732 8.98546,15.108 C8.97746,15.196 8.97346,15.324 8.97346,15.492 C8.97346,15.556 8.99746,15.612 9.04546,15.66 C9.09346,15.708 9.15346,15.732 9.22546,15.732 L9.22546,15.732 L10.41346,15.732 Z M10.37746,18 C10.46546,18 10.53746,17.972 10.59346,17.916 C10.64946,17.86 10.67746,17.792 10.67746,17.712 L10.67746,17.712 L10.67746,16.644 C10.67746,16.564 10.64746,16.496 10.58746,16.44 C10.52746,16.384 10.45746,16.356 10.37746,16.356 L10.37746,16.356 L9.18946,16.356 C9.10946,16.356 9.04146,16.384 8.98546,16.44 C8.92946,16.496 8.90146,16.564 8.90146,16.644 L8.90146,16.644 L8.90146,17.712 C8.90146,17.792 8.92946,17.86 8.98546,17.916 C9.04146,17.972 9.10946,18 9.18946,18 L9.18946,18 L10.37746,18 Z"
                id="?"
                fill="#00B7C1"
              ></path>
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }),
);
